<template>
  <hic-list-page
    ref="listPage"
    title="患者"
    :entities="entities"
    :condition="condition"
    @load="page"
    :loading="meta.loading"
    header-height="6rem"
    keyword-placeholder="患者姓名"
    exportable
    @export="download"
    :show-model-switch="condition.state == '已入住'"
    :card-model.sync="meta.cardModel"
    @cardModelChange="modelChange"
  >
    <template slot="search">
      <el-date-picker @change="changeDate" style="width: 270px" size="small" v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <hic-dict-selector v-model="condition.wardCode" dict-type="IpWard" placeholder="病区" class="condition-input" size="small" @change="page"></hic-dict-selector>
    </template>
    <template slot="extend">
      <el-tabs v-model="condition.state" @tab-click="page">
        <el-tab-pane label="在科患者" name="已入住"> </el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="待入科" name="已登记"> </el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="待转入" name="待转入"> </el-tab-pane>
        <el-tab-pane label="离院患者" name="已离院"> </el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="已结算患者" name="已结算"> </el-tab-pane>
      </el-tabs>
    </template>

    <!-- <el-table-column label="住院号" align="center" prop="ipNo" sortable="custom" width="150">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="openPatient(row)">{{ row.ipNo }}</el-link>
      </template>
    </el-table-column> -->
    <el-table-column v-if="condition.state == '已入住'" label="床位" align="left" prop="bedNo" sortable="custom" width="150" key="bedNo">
      <template slot-scope="{ row }">
        <el-badge :value="row.news" class="item" :hidden="!row.news" style="margin: 0.5rem 0">
          <el-link :type="!row.news ? 'primary' : 'danger'" @click="openPatient(row, 'patientAdvice')" class="bold-title">
            {{ row.bedNo }}
          </el-link>
        </el-badge>
      </template>
    </el-table-column>

    <el-table-column v-if="condition.state == '已入住'" label="操作" prop="patientName" width="120" align="center">
      <template slot-scope="{ row }">
        <!-- <el-popconfirm v-if="$utils.Dt.span(row.checkInDate, $utils.Dt.now()) == 0" title="确定要取消入科操作吗？患者会恢复到入科前状态！" @confirm="cancelCheckIn(row)">
            <el-link slot="reference" type="primary"  class="left-pad danger">取消入科</el-link>
          </el-popconfirm> -->
        <el-dropdown slot="tools" type="text" plain size="mini" class="primary">
          <el-button type="primary" size="mini" plain icon="el-icon-edit-outline" @click="openPatient(row, 'patientVitalSign')">体征 <i class="el-icon-arrow-down el-icon--right" /></el-button>
          <el-dropdown-menu slot="dropdown">
            <template v-if="!setting.isSimple">
              <el-dropdown-item @click.native="openDialog(row, 'addFee')" icon="el-icon-money" class="success">补费用</el-dropdown-item>
              <el-dropdown-item @click.native="openDialog(row, 'refundFee')" icon="el-icon-money" class="danger">退费用</el-dropdown-item>
              <el-dropdown-item @click.native="openDialog(row, 'changeBed')" icon="el-icon-box" class="warning">调床位</el-dropdown-item>
              <el-dropdown-item icon="el-icon-printer">打腕带</el-dropdown-item>
            </template>
            <template v-else>
              <el-dropdown-item @click.native="openDialog(row, 'changeBed')" icon="el-icon-box" class="warning">调床位</el-dropdown-item>
            </template>
            <el-dropdown-item class="info" @click.native="historyBed(row)">
              <el-popover placement="right" title="" trigger="click">
                <el-row class="center info bottom-pad">
                  <b>共 {{ logEngities.items.length }} 条</b>
                </el-row>
                <el-scrollbar style="height: 20rem">
                  <el-timeline style="margin-left: -1rem; padding: 0 2rem">
                    <el-timeline-item v-for="(log, index) in logEngities.items" :key="index" :timestamp="bedInfo(log)" :type="log.type == '入院' ? 'warning ' : log.type == '调床' ? 'success' : 'danger'">
                      <span>{{ log.type }} ：</span> <span>{{ log.startTime | fmtDate }}</span> <span v-if="log.endTime">至 {{ log.endTime | fmtDate }} </span> <span v-else>至 今</span>
                    </el-timeline-item>
                  </el-timeline>
                </el-scrollbar>
                <div slot="reference"><i class="el-icon-warning-outline"></i>历史床位</div>
              </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
    <el-table-column label="姓名" prop="patientName" width="200" align="left">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="openPatient(row)">
          {{ row.patientName }}
        </el-link>
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state != '已入住' && condition.state != '已离院'  && condition.state != '已结算'" type="expand" width="30" key="expand">
      <template slot-scope="{ row }">
        <el-card style="margin-left: 1rem; margin-right: 1rem">
          <el-row slot="header">
            <el-col :span="8" style="margin-top: -1.5rem; margin-bottom: -2.5rem">
              <el-row type="flex" align="middle">
                <h2 class="center">{{ row.patientName }}</h2>
                <el-tag type="primary" plain hit size="mini" class="left-pad">{{ row.state }}</el-tag>
                <el-tag type="danger" plain hit size="mini" class="left-pad" v-if="row.ifBaby">新生儿</el-tag>
              </el-row>
              <el-row style="margin-top: -0.5rem">{{ row.ipNo }}</el-row>
            </el-col>
            <el-col :span="16">
              <el-row type="flex" align="middle" justify="end">
                <!-- <el-button v-if="condition.state == '已入住' && !row.transferTargetCode" type="primary" size="small" icon="el-icon-money" @click="showTransfer(row, '转科')" class="left-pad" plain>转科</el-button> -->
                <el-button v-if="condition.state == '已入住' && row.transferTargetCode" type="danger" size="small" icon="el-icon-refresh-left" @click="cancelTransfer(row)" class="left-pad" plain>取消转科</el-button>

                <el-button v-if="condition.state == '已登记' || condition.state == '待转入'" type="primary" size="small" icon="el-icon-add-location" @click="checkIn(row)" class="left-pad" plain>入科</el-button>

                <!-- <el-button v-if="row.state != Enum.HospitalizationState.已结算" type="info" size="small" icon="el-icon-edit" @click="showPatient(row)" class="left-pad" plain>患者详细</el-button> -->
                <el-button v-if="row.state == Enum.HospitalizationState.已离院" type="danger" size="small" icon="el-icon-refresh-left" @click="cancelOut(row)" class="left-pad" plain>取消离院</el-button>
              </el-row>
            </el-col>
          </el-row>
          <!-- <el-descriptions v-if="row.state == Enum.HospitalizationState.已登记" :column="4" contentClassName="right-pad" :contentStyle="{'margin-top': '-0.4rem'}">
            <div slot="title" class="primary">当前患者是新入院患者，请选择床位及责任人，然后点击【入科按钮】进行入科操作！</div>
            <el-descriptions-item label="入院日期"><el-date-picker v-model="row.startDate" size="small" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" /></el-descriptions-item>
            <el-descriptions-item label="入住科室">
              <el-tag type="info" hit effect="dark" class="f-w">{{ $utils.Dict.text(user.deptCode, "Dept") }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="入住病区"><hic-dict-selector dict-type="IpWard" v-model="row.wardCode" @change="wardChange(row)"></hic-dict-selector></el-descriptions-item>
            <el-descriptions-item label="入住床位">
              <el-select v-model="row.bedId" size="small" @change="bedChange(row)">
                <el-option v-for="item in freeBeds.filter((b) => !row.wardCode || b.wardCode == row.wardCode)" :key="item.id" :value="item.id">
                  No. {{ item.no }} <small>（{{ item.building }} 楼 - {{ item.room }} 房）</small>
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="主治医师"><hic-staff-selector :dept="user.deptCode" v-model="row.doctorCode" :name.sync="row.doctorName" class="f-w" /></el-descriptions-item>
            <el-descriptions-item label="责任护士"><hic-staff-selector :dept="user.deptCode" v-model="row.nurseCode" :name.sync="row.nurseName" class="f-w" /></el-descriptions-item>
          </el-descriptions> -->
          <div v-if="row.state == Enum.HospitalizationState.已登记">
            <h3 class="warning">当前患者是新入院患者，请选择床位及责任人，然后点击【入科】按钮，进行入科操作！</h3>
            <el-form :model="row" label-width="90px" :rules="rules" :ref="'form' + row.id">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="入院日期:" prop="startDate">
                    <el-date-picker v-model="row.startDate" size="small" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入住科室:">
                    <el-tag type="info" hit effect="light" class="f-w">
                      {{ $utils.Dict.text(user.deptCode, "Dept") }}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入住病区:" prop="wardCode">
                    <hic-dict-selector dict-type="IpWard" v-model="row.wardCode" @change="wardChange(row)"></hic-dict-selector>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入住床位:" prop="bedId">
                    <!-- <el-select v-model="row.bedId" size="small" @change="bedChange(row)">
                      <el-option v-for="item in freeBeds.filter((b) => !row.wardCode || b.wardCode == row.wardCode)" :key="item.id" :value="item.id">
                        No. {{ item.no }} <small>（{{ item.building }} 楼 - {{ item.room }} 房）</small>
                      </el-option>
                    </el-select> -->
                    <el-cascader v-model="row.bedIds" size="small" :options="bedOptions(row.wardCode)" :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" @change="bedChange(row)" class="f-w" :show-all-levels="false"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="住院医师:" prop="doctorCode">
                    <hic-staff-selector :dept="user.deptCode" v-model="row.doctorCode" :name.sync="row.doctorName" class="f-w"></hic-staff-selector>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="责任护士:" prop="nurseCode">
                    <hic-staff-selector :dept="user.deptCode" v-model="row.nurseCode" :name.sync="row.nurseName" class="f-w"></hic-staff-selector>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主治医师:" prop="masterCode">
                    <hic-staff-selector :dept="user.deptCode" v-model="row.masterCode" :name.sync="row.masterName" class="f-w"></hic-staff-selector>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主任医师:" prop="directorCode">
                    <hic-staff-selector :dept="user.deptCode" v-model="row.directorCode" :name.sync="row.directorName" class="f-w"></hic-staff-selector>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-descriptions v-if="row.state == Enum.HospitalizationState.已入住 || row.state == Enum.HospitalizationState.已离院" title="在院情况" :column="4">
            <el-descriptions-item label="主治医师">{{ row.doctorName }}</el-descriptions-item>
            <el-descriptions-item label="责任护士">{{ row.nurseName }}</el-descriptions-item>
            <el-descriptions-item label="护理等级">{{ row.nursingGrade }}</el-descriptions-item>
            <el-descriptions-item label="危重等级">{{ row.criticalLevel }}</el-descriptions-item>
            <el-descriptions-item label="当前科室">{{ $utils.Dict.text(row.deptCode, "Dept") }}</el-descriptions-item>
            <el-descriptions-item label="当前病区">{{ $utils.Dict.text(row.wardCode, "IpWard") }}</el-descriptions-item>
            <el-descriptions-item label="床位编号">{{ row.bedNo }}</el-descriptions-item>
            <el-descriptions-item label="在院天数">{{ Math.trunc($utils.Dt.span(row.startDate, new Date(), "d")) }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="财务情况" :column="4">
            <el-descriptions-item label="预交金额">{{ row.state }}</el-descriptions-item>
            <el-descriptions-item label="记账金额">{{ row.state }}</el-descriptions-item>
            <el-descriptions-item label="挂账状态"><el-tag type="danger" plain hit v-if="row.ifBillingEnd">已挂账</el-tag></el-descriptions-item>
            <el-descriptions-item label="挂账时间">{{ row.billingEndDate }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="入院情况" :column="4">
            <el-descriptions-item label="入院时间">
              <span v-if="row.startDate">{{ row.startDate | fmtDate }}</span>
              <span v-else>待入院</span>
            </el-descriptions-item>
            <el-descriptions-item label="住院类型">{{ $utils.Dict.text(row.stayType, "IpStayType") }}</el-descriptions-item>
            <el-descriptions-item label="入院科室">{{ $utils.Dict.text(row.originalDeptCode, "Dept") }}</el-descriptions-item>
            <el-descriptions-item label="住院次数">第 {{ row.stayTimes }} 次</el-descriptions-item>
            <el-descriptions-item label="入院途径">{{ $utils.Dict.text(row.comeFrom, "IpComeFrom") }}</el-descriptions-item>
            <el-descriptions-item label="门诊医师">{{ row.opDoctorName }}</el-descriptions-item>
            <el-descriptions-item label="门诊科室">{{ $utils.Dict.text(row.opDeptCode, "Dept") }}</el-descriptions-item>
            <el-descriptions-item label="门诊诊断">{{ row.diagnosisName }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions v-if="row.state == Enum.HospitalizationState.已离院 || row.state == Enum.HospitalizationState.已结算" title="离院情况" :column="4">
            <el-descriptions-item label="离院时间">{{ row.endDate }}</el-descriptions-item>
            <el-descriptions-item label="离院方式">{{ row.leaveMode }}</el-descriptions-item>
            <el-descriptions-item label="离院状况">{{ row.leaveStatus }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
      </template>
    </el-table-column>
    <el-table-column label="性别" prop="patientGender" sortable="custom" align="center" width="80" key="patientGender">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientBirthday" sortable="custom" align="right" width="80" key="patientAge">
      <template slot-scope="{ row }">
        {{ row.patientAge }}
      </template>
    </el-table-column>
    <el-table-column label="入院科室" align="center" prop="originalDeptCode" sortable="custom" width="150" key="originalDeptCode">
      <template slot-scope="{ row }">
        {{ row.originalDeptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column label="诊断" align="left" prop="diagnosisName" sortable="custom" key="diagnosisName">
      <template slot-scope="{ row }">
        <span v-if="row.diagnosisName">{{ row.diagnosisName }}</span>
        <span v-if="row.diagnosisCode"> ({{ row.diagnosisCode }})</span>
      </template>
    </el-table-column>
    <el-table-column label="主治医师" align="center" prop="doctorName" sortable="custom" key="doctorName" width="100"></el-table-column>
    <el-table-column label="责任护士" align="center" prop="nurseName" sortable="custom" key="nurseName" width="100"></el-table-column>
    <el-table-column label="收费类别" align="center" prop="ipType" sortable="custom" key="ipType" width="100">
      <template slot-scope="{ row }">
        <el-tag size="small" type="warning" plain hit v-if="row.ipType == Enum.IpType.自费">{{ row.ipType }}</el-tag>
        <el-tag size="small" type="success" plain hit v-if="row.ipType == Enum.IpType.医保">{{ row.ipType }}</el-tag>
        <el-tag size="small" type="danger" plain hit v-if="row.ipType == Enum.IpType.医保工伤">{{ row.ipType }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="费用" align="right" prop="amount" sortable="custom" key="amount" width="100">
      <template slot-scope="{ row }">
        <span class="danger"> ￥{{ (row.amount || 0) | fmtFloat }}</span>
      </template>
    </el-table-column>
    <el-table-column label="余额" align="right" prop="balance" sortable="custom" key="balance" width="100">
      <template slot-scope="{ row }">
        <span :class="(row.balance || 0) <= 0 ? 'danger' : 'success'"> ￥{{ (row.balance || 0) | fmtFloat }}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state != Enum.HospitalizationState.已登记" label="在院天数" align="right" width="100">
      <template slot-scope="{ row }">
        {{ $utils.Dt.span(row.startDate, $utils.Dt.now(), "d") }}
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state != Enum.HospitalizationState.已登记" label="入院日期" align="left" width="100" prop="startDate" sortable="custom" key="入院日期">
      <template slot-scope="{ row }">
        {{ row.startDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state != Enum.HospitalizationState.已登记" label="入科日期" align="left" width="100" prop="checkInDate" sortable="custom" key="入科日期">
      <template slot-scope="{ row }">
        {{ row.checkInDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state == Enum.HospitalizationState.已离院 || condition.state == Enum.HospitalizationState.已结算" label="离院方式" align="center" prop="leaveMode" key="leaveMode">
      <template slot-scope="{ row }">
        <div>{{ row.leaveMode | dictText("IpLeaveMode") }}</div>
      </template>
    </el-table-column>
    <template #card="{ row }">
      <hic-hospitalization-card :entity="row" @click="openPatient(row, 'patientAdvice')">
        <el-dropdown slot="tools" type="text" plain size="mini" class="primary">
          <el-button type="primary" size="mini" plain icon="el-icon-search" @click="openPatient(row, 'patientAdvice')">医嘱 <i class="el-icon-arrow-down el-icon--right" /></el-button>
          <el-dropdown-menu slot="dropdown">
            <template v-if="!setting.isSimple">
              <el-dropdown-item @click.native="openDialog(row, 'addFee')" icon="el-icon-money" class="success">补费用</el-dropdown-item>
              <el-dropdown-item @click.native="openDialog(row, 'refundFee')" icon="el-icon-money" class="danger">退费用</el-dropdown-item>
              <el-dropdown-item @click.native="openDialog(row, 'changeBed')" icon="el-icon-box" class="warning">调床位</el-dropdown-item>
              <el-dropdown-item icon="el-icon-printer">打腕带</el-dropdown-item>
            </template>
            <template v-else>
              <el-dropdown-item @click.native="openDialog(row, 'changeBed')" icon="el-icon-box" class="warning">调床位</el-dropdown-item>
            </template>

            <el-dropdown-item class="info" @click.native="historyBed(row)">
              <el-popover placement="right" title="" trigger="click">
                <el-row class="center info bottom-pad">
                  <b>共 {{ logEngities.items.length }} 条</b>
                </el-row>
                <el-scrollbar style="height: 20rem">
                  <el-timeline style="margin-left: -1rem; padding: 0 2rem">
                    <el-timeline-item v-for="(log, index) in logEngities.items" :key="index" :timestamp="bedInfo(log)" :type="log.type == '入院' ? 'warning ' : log.type == '调床' ? 'success' : 'danger'">
                      <span>{{ log.type }} ：</span> <span>{{ log.startTime | fmtDate }}</span> <span v-if="log.endTime">至 {{ log.endTime | fmtDate }} </span> <span v-else>至 今</span>
                    </el-timeline-item>
                  </el-timeline>
                </el-scrollbar>
                <div slot="reference"><i class="el-icon-warning-outline"></i>历史床位</div>
              </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </hic-hospitalization-card>
    </template>

    <!-- <hic-patient-dialog :visible.sync="meta.showPatient" :id="patientCode" :editable="true" /> -->
    <Transfer :visible.sync="meta.showTransfer" :infoDetail="transferPatinent" :title="sleTitle" @close="page" />
    <hic-hospitalization-dialog :visible.sync="meta.showCard" :entity="entity" @cancelCheckIn="cancelCheckIn" :default-tab="meta.defaultTab" :condition="condition" @close="closeCard">
      <template #menus>
        <el-menu-item index="patientAdvice">医嘱处置</el-menu-item>
        <el-menu-item index="patientVitalSign">生命体征</el-menu-item>
        <el-menu-item index="patientDrug">药品管理</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientEmr">护理文书</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientFee">费用管理</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientExamine">检查检验报告</el-menu-item>
        <el-menu-item index="patientInfo">患者概览</el-menu-item>
      </template>
      <template #main="{ data }">
        <Emr v-if="!setting.isSimple" v-show="$route.name == 'patientEmr'" :entity="data"></Emr>
      </template>
    </hic-hospitalization-dialog>
    <addFee :visible.sync="meta.showAddFee" :infoDetail="selInfo" :title="sleTitle" @close="page" />
    <refundFee :visible.sync="meta.showRefundFee" :infoDetail="selInfo" :title="sleTitle" @close="page" />
    <hic-hospitalization-beds-dialog :visible.sync="meta.bedChanging" :hospitalization="entity || {}" :hide-wrap="setting.isSimple" />
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapState, mapGetters } from "sw-hic";
  export default {
    components: {
      Transfer: () => import("./transfer"),
      addFee: () => import("../fee/feeManage"),
      refundFee: () => import("../fee/feeManage"),
      Emr: () => import("./card/emr.vue"),
    },
    data() {
      return {
        date:null,
        patientCode: null,
        title: "",
        meta: {
          loading: false,
          showPatient: false,
          showDeposit: false,
          showTransfer: false,
          showCard: false,
          cardModel: false,
          defaultTab: null,
          showAddFee: false,
          showRefundFee: false,
          bedChanging: false,
        },
        condition: {
          state: null,
          sort: "bedNo",
          asc: true,
          pageSize: 100,
          pageIndexOnView: 1,
        },
        entities: {
          items: [],
          selected: null,
        },
        selInfo: {},
        entity: null,
        freeBeds: [],
        transferPatinent: {},
        sleTitle: "",
        rules: {
          startDate: [{ required: true, message: "请选择入院日期", trigger: "blur" }],
          bedId: [{ required: true, message: "请选择床位", trigger: "change" }],
          doctorCode: [{ required: true, message: "请选择主治医师是", trigger: "change" }],
          nurseCode: [{ required: true, message: "请选择责任护士、", trigger: "change" }],
          // 可以根据需要为其他字段添加验证规则
        },
        logEngities: { items: [] },
        beds: [],
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "user", "setting"]),
      ...mapState(["notifyIpNos"]),
      bedOptions() {
        return (wardCode) => {
          let beds = [];
          for (let bed of this.freeBeds.filter((i) => !wardCode || i.wardCode == wardCode)) {
            let { building, floor, room, no, id } = bed;
            let b = beds.find((item) => item.value == building);
            if (!b) {
              b = {
                value: building,
                label: this.$utils.Dict.text(building, "Building"),
                children: [],
              };
              beds.push(b);
            }
            let f = b.children.find((item) => item.value == floor);
            if (!f) {
              f = {
                value: floor,
                label: this.$utils.Dict.text(floor, "Floor"),
                children: [],
              };
              b.children.push(f);
            }
            let r = f.children.find((item) => item.value == room);
            if (!r) {
              r = {
                value: room,
                label: this.$utils.Dict.text(room, "Room"),
                children: [],
              };
              f.children.push(r);
            }
            let n = r.children.find((item) => item.value == no);
            if (!n) {
              n = {
                value: id,
                label: no,
              };
              r.children.push(n);
            }
          }
          return beds;
        };
      },
    },
    created() {
      this.condition.state = this.Enum.HospitalizationState.已入住;
      this.condition.deptCode = this.user.deptCode;
      this.queryBed();
      let model = this.$utils.Repository.get("nurse_hospitalization_model");
      if (model != undefined) {
        this.meta.cardModel = model;
      }
    },
    methods: {
      changeDate(d){
        if (d) {
          this.condition.startDateSt = this.$utils.Fmt.date(d[0]) + " 00:00:00";
          this.condition.startDateEd = this.$utils.Fmt.date(d[1]) + " 23:59:59";
        } else {
          this.condition.startDateSt = null
          this.condition.startDateEd = null
        }
        
        this.page()
      },
      page() {
        if (this.condition.state != this.Enum.HospitalizationState.已入住) {
          this.meta.cardModel = false;
        } else {
          let model = this.$utils.Repository.get("nurse_hospitalization_model");
          if (model != undefined) {
            this.meta.cardModel = model;
          }
        }
        let con = this.$utils.Obj.clone(this.condition);
        switch (con.state) {
          case this.Enum.HospitalizationState.已登记:
            con.originalDeptCode = this.user.deptCode;
            break;
          case "待转入":
            con.state = this.Enum.HospitalizationState.已入住;
            con.transferTargetCode = this.user.deptCode;
            break;
          default:
            con.deptCode = this.user.deptCode;
        }
        this.meta.loading = true;
        if(con.sort == 'patientBirthday' || con.sort == 'startDate') con.asc = !this.condition.asc
        api.Hospitalization.query(con)
          .then((res) => {
            this.entities = this.checkInDataInit(res);
            this.queryNews();
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      checkInDataInit(res) {
        if (this.Enum.HospitalizationState.已登记 == this.condition.state) {
          // 新入院，入科前初始化数据
          res.items.forEach((item) => {
            if (!item.startDate) {
              item.startDate = this.$utils.Dt.now();
            }
            if (!item.doctorCode && item.originalDeptCode == item.opDeptCode) {
              item.doctorCode = item.opDoctorCode;
            }
          });
        }
        return res;
      },
      queryNews() {
        if (this.entities.items.length) {
          api.Advice.query({
            deptCode: this.user.deptCode,
            states: ["待校对", "待停止"],
            ifDetail: false,
            isMaster: true,
          }).then((res) => {
            if (res.items.length) {
              this.entities.items.forEach((item) => {
                this.$set(item, "news", res.items.filter((a) => a.hospitalizationId == item.id).length);
              });
            }
          });
        }
      },
      openPatient(row, cmd) {
        this.meta.defaultTab = cmd;
        this.entity = row;
        this.meta.showCard = true;
      },
      async queryBed(wardCode) {
        this.freeBeds = (
          await api.Bed.query({
            wardCode: wardCode,
            nulls: "ipNo",
          })
        ).items;
        if (wardCode) {
          return this.freeBeds.filter((b) => b.wardCode == wardCode);
        }
        return this.freeBeds;
      },
      showPatient(row) {
        this.patientCode = row.patientCode;
        this.meta.showPatient = true;
      },
      showDeposit(row) {
        this.$set(this.entities, "selected", row);
        this.meta.showDeposit = true;
      },
      showTransfer(row, title) {
        this.sleTitle = title;
        this.transferPatinent = row;
        this.meta.showTransfer = true;
      },
      cancelTransfer(row) {
        let self = this;
        self
          .$confirm("确定要取消转科？", "取消", { type: "warning", cancelButtonText: "关闭" })
          .then(() => {
            self.meta.loading = true;
            api.Hospitalization.cancelCheckout(row.id)
              .then((res) => {
                self.meta.loading = false;
                self.$message.success("取消成功");
                self.page();
              })
              .catch((err) => {
                self.meta.loading = false;
                self.$message.error(err);
              });
          })
          .catch((e) => {});
      },
      cancelOut(row) {
        let self = this;
        self
          .$confirm("确定要取消出院？", "取消", { type: "warning", cancelButtonText: "关闭" })
          .then(() => {
            self.meta.loading = true;
            api.Hospitalization.cancelOut(row.id)
              .then((res) => {
                self.meta.loading = false;
                self.$message.success("取消成功");
                if (!res.bedNo) {
                  self.$message.success("当前患者之前床位已被占用，请重新分配床位！");
                }
                self.page();
              })
              .catch((err) => {
                self.meta.loading = false;
                self.$message.error(err);
              });
          })
          .catch((e) => {});
      },
      download() {
        api.Hospitalization.export(this.condition, "住院患者.xls", [
          { property: "patientName", title: "姓名" },
          { property: "patientGender", title: "性别", dict: "Gender" },
          { property: "patientAge", title: "年龄" },
          { property: "originalDeptCode", title: "入院科室", dict: "Dept" },
        ]);
      },
      wardChange(row) {
        row.bedId = null;
        row.bedNo = null;
      },
      bedChange(row) {
        if (row.bedIds.length) {
          let bed = this.freeBeds.find((b) => b.id == row.bedIds[0]);
          if (bed) {
            row.bedId = bed.id;
            row.bedNo = bed.no;
            if (!row.wardCode) {
              row.wardCode = bed.wardCode;
            }
          }
        } else {
          row.bedId = null;
          row.bedNo = null;
        }
      },
      checkIn(row) {
        this.$refs[`form${row.id}`].validate((valid) => {
          if (valid) {
            row.deptCode = this.user.deptCode;
            // row.bedId = row.bedIds[0]
            // row.bedNo = this.freeBeds.find((b) => b.id == row.bedIds[0]).no;
            api.Hospitalization.checkIn(row.id, row)
              .then((res) => {
                this.page();
              })
              .catch((err) => {
                this.$message.error(err);
              });
          }
        });
      },
      cancelCheckIn(row) {
        api.Hospitalization.cancelCheckIn(row.id)
          .then((res) => {
            this.meta.showCard = false;
            this.condition.state = res.state;
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      modelChange(model) {
        this.$utils.Repository.set("nurse_hospitalization_model", model);
      },
      openDialog(row, type) {
        this.entity = null;
        this.selInfo = this.$utils.Obj.clone(row);
        switch (type) {
          case "addFee":
            this.meta.showAddFee = true;
            break;
          case "refundFee":
            this.meta.showRefundFee = true;
            break;
          case "changeBed":
            this.entity = row;
            this.meta.bedChanging = true;
            break;
        }
        // type == "addFee" ? (this.meta.showAddFee = true) : (this.meta.showRefundFee = true);
      },

      historyBed(row) {
        this.meta.showBedLog = true;
        api.BedLog.query({ hospitalizationId: row.id, sort: "id", asc: false })
          .then((res) => {
            this.logEngities = res;
            return api.Bed.query({ ids: res.items.map((l) => l.bedId) });
          })
          .then((res) => {
            this.beds = res.items;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.showBedLog = false;
          });
      },
      bedInfo(log) {
        if (this.beds) {
          let days = this.$utils.Dt.span(log.startTime, log.endTime || this.$utils.Dt.now(), "d");
          let bed = this.beds.find((i) => i.id == log.bedId);
          if (bed) {
            return `${bed.no} ${this.$utils.Dict.text(bed.type, "BedType")}床 ${days}天`;
          }
        }
        return null;
      },
      closeCard() {
        this.meta.showCard=false
        this.$router.replace({name: "patient"})
        this.entity = {};
      }
    },
  };
</script>
